import { Alert } from "@mui/material";

// Shown when the page is displaying built-in sample content because the API did not answer.
export default function FallbackNotice({ show }) {
  if (!show) return null;
  return (
    <Alert severity="warning" sx={{ mb: 3 }}>
      The VEYSO API is not reachable, so this page is showing built-in sample content.
    </Alert>
  );
}
